import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Link } from 'react-router-dom';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const ErrorContainer = styled.div`
  text-align: center;
  animation: ${fadeIn} 2s ease-in-out;
  background-color: #f8f9fa;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: Arial, sans-serif;
`;

const ErrorTitle = styled.h1`
  font-size: 10rem;
  color: #343a40;
`;

const ErrorMessage = styled.p`
  font-size: 1.5rem;
  color: #6c757d;
`;

function Error() {
  return (
    <ErrorContainer>
      <div>
        <ErrorTitle>404</ErrorTitle>
        <ErrorMessage>Página não encontrada</ErrorMessage>
        <br></br>
        <Link to="/home">
          <button className='error_button'>
            Clique aqui para voltar ao Inicio
          </button>
        </Link>
      </div>
    </ErrorContainer>
  );
}

export default Error;
